jQuery(document).ready(function ($) {
    $('.dashboard-toggle').click(function () {
        var container = $('.cockpit-menu-container');
        container.addClass('active');
        $('body').addClass('not-scroll');
        $('.contact-container-floating').fadeOut();
        if (container.hasClass('active')) {
            $(document).mouseup(function (e) {
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    container.removeClass('active');
                    $('body').removeClass('not-scroll');
                    $('.contact-container-floating').fadeIn();
                }
            });
            
        }
    })
})